// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Header_Logo__3U3EH","AuthContainer":"Header_AuthContainer__30Lqi"};